import Vue from "vue";
import VueI18n from "vue-i18n";

Vue.use(VueI18n);

// Ready translated locale messages
const messages = {
  en: {
    action: {
      contactUs: "Contact Us",
      callUs: "Call Us",
    },
    day: {
      monday: "Monday",
      friday: "Friday",
    },
    title: {
      trendAndStats: "Trend and Statistics",
      eventList: "Event list",
      eventDetails: "Event details",
      /* Trend */
      displacementTrend: "Displacement Trend",
      txTrend: "Transmission Trend",
      txCount: "Transmissions",
      tempTrend: "Temperature Trend",
      dataSummary: "Data summary",
      /* Stats */
      peakStats: "Displacement Statistics",
      accStats: "Acceleration Statistic",
      densProbDisp: "Pk-Pk Displacement Probability Density Function",
      densProbAcc: "Pk-Pk Acceleration Probability Density Function",
      modalFreq: "Modal Frequencies Statistics",
      anomalyDisp: "Anomaly Displacement Detector"
    },
    subTitle: {
      eventList: "Select an event or sample detected by the selected sensor",
    },
    dataType: {
      accelerations: "Accelerations",
      extensions: "Extensions",
      tilts: "Tilts",
      displacements: "Displacements",
      acceleration: "Acceleration",
      crack: "Extension",
      tilt: "Tilt",
      temperature: "Temperature",
      displacement: "Displacement",
      amplitudeSpectrum: "Amplitude Spectrum",
      frequency: "Frequency",
    },
    message: {
      /* Warning */
      irreversibleWarning: "This cannot be undone. Are you sure you want to continue? ",
      compensationWarning: "By deactivating the function, the absolute data (read by the instrument) will be displayed, without any compensation related to the installation mode.",
      deviceselect: "Select the device",
      multiDeckSelect: "Select one or more Deck device",
      deviceselectinfo: "This section displays the data about the last transmission and the battery level of the device. You can also select a specific Deck sensor to gain more information about it",
      bridgescroll: "Swipe the bridge to view all sensors",
      coordinates: "coordinates",
      monitoredSpans: "monitored spans",
      installedDevices: "installed devices",
      installDate: "Install date",
      startDate: "Start Date",
      endDate: "End date",
      dateRange: "Date range",
      notEnoughSensorsOnSpan: "Min. 2 sensors per span required",
      /* Dialog */
      delete: "Delete",
      edit: "Edit",
      undo: "Undo",
      update: "Update",
      loading: "Loading",
      noDataInRange: "No data in selected range",
      noDataForSensor: "No data is available for the selected device",
      activatedF: "Activated",
      deactivatedF: "Deactivated",
      activeF: "Active",
      inactiveF: "Inactive",
      selectAll: "Select All",
      deselectAll: "Deselect All",
      reset: "Reset",
      resetAll: "Reset all",
      noData: "No data",
      saveChanges: "Save changes",
      logInCaption: "Welcome Back! Log in to continue.",
      helpMe: "Need help?",
      helpDesk: "Customer service",
      /* Date */
      last7Days: "Last 7 days",
      last15Days: "Last 15 days",
      last30Days: "Last 30 Days",
      last12Weeks: "Last 12 Weeks",
      last6Months: "Last 6 Months",
      last12Months: "Last 12 Months",
      date: "Date",
      /* Devices */
      deck: "Deck",
      tiltmeter: "Tiltmeter",
      accelerometer: "Accelerometer",
      crackmeter: "Crackmeter",
      analogNode: "Analog Node",
      decks: "Deck",
      tiltmeters: "Tiltmeters",
      accelerometers: "Accelerometers",
      crackmeters: "Crackmeters",
      analogNodes: "Analog Nodes",
      /* Options */
      dashboard: "Dashboard",
      events: "Events",
      statistics: "Statistics",
      settings: "Settings",
      statusMonitor: "Status Monitor",
      notifications: "Notifications",
      manage: "Management",
      summary: "Summary",
      alertThreshold: "Alarm",
      structure: "Structure",
      spans: "Spans",
      span: "Span",
      addSpan: "Add a New Span",
      setSpans: "Set the bridge spans",
      setSensorSpan: "Set the sensor positioning on the structure span",
      positioning: "Positioning",
      mailNotifications: "Mail notifications",
      mailAddresses: "Mail addresses",
      mailAddressesExplain: "Receive notifications when the threshold is exceeded",
      setSampleRate: "Set the sample rate of the following devices",
      setResolution: "Set the resolution of the following devices",
      manageDevices: "Customize and rename the following devices",
      resetCompensation: "Reset the compensation offset of the following devices",
      compensated: "Compensation executed",
      notCompensated: "Compensation not executed yet",
      setActivationThreshold: "Set the minimum activation threshold for data sampling of the following devices",
      alertDevices: "When the set value (Peak to Peak) is exceeded, a notification email will be sent. Set the alarm threshold of the following devices",
      globalStatus: "Global system status",
      newMailAddress: "Enter a new mail address",
      logIn: "Log in",
      groupSelection: "Selected group",
      mesUnitSelect: "Select Unit of Measurement",
      users: "Users",
      manageUsers: "Manage the guest users",
      addUser: "Insert a new guest user",
      editPsw: "Insert/Edit password",
      descending: "Descending",
      ascending: "Ascending",
      allSensors: "All sensors",
      selSensor: "Selected sensor",
      /* Graphs */
      displacementGraph: "Displacement Graph",
      accelerationsGraph: "Accelerations Graph",
      tiltGraph: "Tilt Graph",
      tilt3dGraph: "3D variation angle",
      crackGraph: "Extension Graph",
      temperatureGraph: "Temperature Graph",
      densProb: "Probability Density Function",
      freqApp: "Probability Density",
      deflectionGraph: "Deflection",
      deflectionDesc: "Structure lowering graph",
      /* Infos */
      dataOf: "Data of",
      dataOfSelectedDevice: "Data of the selected device",
      deviceInfo: "Device info",
      dateSorting:"Sort by date",
      last24Data: "Last 24h data",
      lastTemperature: "Last recorded temperature",
      lastTX: "Last TX",
      samples: "Samples",
      deviceData: "Data of the Dev_EUI",
      deckMultiData: "Data of all selected Deck devices",
      maxPeak: "Maximum peak",
      minPeak: "Minimum peak",
      peakToPeak: "Peak to Peak",
      maxAcceleration: "Maximum acceleration",
      maxCrack: "Maximum extension",
      maxTilt: "Maximum tilt",
      minTemp: "Minimum temperature",
      maxTemp: "Maximum temperature",
      dailyAverageEvents: "Daily average number of events",
      counterEvents: "Number of events",
      thresholdCrossingCount: "Threshold crossing count",
      selectedDevices: "Selected devices",
      meanValue: "Average value",
      minValue: "Min value",
      maxValue: "Max value",
      variance: "Variance",
      stdDeviation: "Std. Deviation",
      /* Functions */
      dataCompensation: "Data compensation",
      sampleRate: "Sample Rate",
      resolution: "Resolution",
      activationThreshold: "Activation",
      compensation: "Compensation",
      mesUnit: "Unit"
    },
  },
  it: {
    action: {
      contactUs: "Contattaci",
      callUs: "Chiamaci",
    },
    day: {
      monday: "Lunedì",
      friday: "Venerdi",
    },
    title: {
      trendAndStats: "Trend e Statistiche",
      eventList: "Elenco degli eventi",
      eventDetails: "Dettagli degli eventi",
      /* Trend */
      displacementTrend: "Trend del Displacement",
      txTrend: "Trend del numero di Trasmissioni",
      txCount: "Numero di Trasmissioni",
      tempTrend: "Trend delle temperature",
      dataSummary: "Riepilogo dei dati",
      /* Stats */
      peakStats: "Statistiche dei picchi di spostamento",
      accStats: "Statistiche dei picchi di accelerazion",
      densProbDisp: "Densità di Probabilità degli spostamenti Pk-Pk",
      densProbAcc: "Densità di Probabilità delle accelerazioni  Pk-Pk",
      modalFreq: "Statistiche delle Frequenze Modali",
      anomalyDisp: "Rivelatore della anomalie di spostamento"
    },
    subTitle: {
      eventList: "Seleziona un evento o un campionamento rilevato dal sensore selezionato",
    },
    dataType: {
      accelerations: "Accelerazioni",
      extensions: "Estensioni",
      tilts: "Angoli",
      displacements: "Displacement",
      acceleration: "Accelerazione",
      crack: "Estensione",
      tilt: "Tilt",
      temperature: "Temperatura",
      displacement: "Displacement",
      amplitudeSpectrum: "Spettro di ampiezza",
      frequency: "Frequenza",
    },
    message: {
      /* Warning */
      irreversibleWarning: "Questa azione non può essere annullata. Sei sicuro di voler procedere? ",
      compensationWarning: "Disattivando la funzionalità si avranno i dati assoluti letti dallo strumento senza alcuna compensazione relativa alla modalità di installazione.",
      deviceselect: "Seleziona il device",
      multiDeckSelect: "Seleziona i molteplici device Deck:",
      deviceselectinfo: "In questa sezione vengono visualizzati i dati relativi all’ultima trasmissione effettuata ed al livello della batteria del dispositivo, è inoltre possibile selezionare uno specifico sensore Deck di cui vuoi approfondire le informazioni.",
      bridgescroll: "Scorri il ponte per visualizzare tutti i sensori",
      coordinates: "coordinate",
      monitoredSpans: "campate monitorate",
      installedDevices: "device installati",
      installDate: "Data di installazione",
      startDate: "Data di inizio",
      endDate: "Data di fine",
      dateRange: "Intervallo di tempo",
      notEnoughSensorsOnSpan: "Min. 2 sensori per campata richiesti",
      /* Dialog */
      delete: "Elimina",
      edit: "Modifica",
      undo: "Annulla",
      update: "Aggiorna",
      loading: "Caricamento",
      noDataInRange: "Nessun dato disponibile per il range scelto",
      noDataForSensor: "Nessun dato disponibile per il device selezionato",
      activatedF: "Attivata",
      deactivatedF: "Disattivata",
      activeF: "Attiva",
      inactiveF: "Non attiva",
      selectAll: "Seleziona Tutto",
      deselectAll: "Deseleziona Tutto",
      reset: "Resetta",
      resetAll: "Resetta tutto",
      noData: "Nessun date",
      saveChanges: "Salva modifiche",
      logInCaption: "Bentornato! Per favore accedi per continuare.",
      helpMe: "Bisogno di assistenza?",
      helpDesk: "Supporto tecnico",
      /* Date */
      last7Days: "Ultimi 7 giorni",
      last15Days: "Ultimi 15 giorni",
      last30Days: "Ultimi 30 giorni",
      last12Weeks: "Ultime 12 settimane",
      last6Months: "Ultimi 6 Mesi",
      last12Months: "Ultimi 12 Mesi",
      date: "Data",
      /* Devices */

      deck: "Deck",
      tiltmeter: "Inclinometro",
      accelerometer: "Accelerometro",
      crackmeter: "Estensimetro",
      analogNode: "Nodo Analogico",
      decks: "Deck",
      tiltmeters: "Inclinometri",
      accelerometers: "Accelerometri",
      crackmeters: "Estensimetri",
      analogNodes: "Nodi Analogici",
      /* Options */
      dashboard: "Dashboard",
      events: "Eventi",
      statistics: "Statistiche",
      settings: "Opzioni",
      statusMonitor: "Stato Sistema",
      notifications: "Notifiche",
      manage: "Gestisci",
      summary: "Riepilogo",
      alertThreshold: "Allarme",
      structure: "Struttura",
      spans: "Campate",
      span: "Campata",
      addSpan: "Aggiungi Nuova Campata",
      setSpans: "Imposta le campate del ponte",
      setSensorSpan: "Imposta il posizionamento del sensore sulla campata",
      positioning: "Posizionamento",
      mailNotifications: "Mail di notifica",
      mailAddresses: "Indirizzi Mail",
      mailAddressesExplain: "Ricevi notifiche di allarme per superamento della soglia",
      setSampleRate: "Imposta la frequenza di campionamento dei seguenti dispositivi",
      setResolution: "Imposta la risoluzione dei seguenti dispositivi",
      manageDevices: "Personalizza e rinomina i seguenti dispositivi",
      resetCompensation: "Resetta l'offset di compensazione dei seguenti dispositivi",
      compensated: "Compensazione eseguita",
      notCompensated: "Compensazione non eseguita",
      setActivationThreshold: "Imposta la soglia minima di attivazione per il campionamento dati dei seguenti dispositivi",
      alertDevices: "Al superamento del valore impostato (Picco-Picco) verrà inviata un’email di notifica. Imposta la soglia d’allarme dei seguenti dispositivi",
      globalStatus: "Stato globale del sistema",
      newMailAddress: "Inserisci un nuovo indirizzo mail",
      logIn: "Accedi",
      groupSelection: "Gruppo selezionato",
      mesUnitSelect: "Seleziona l'unità di misura",
      users: "Utenti",
      manageUsers: "Gestisci gli utenti ospite",
      addUser: "Inserisci un nuovo utente ospite",
      editPsw: "Inserisci/Modifica password",
      descending: "Decrescente",
      ascending: "Crescente",      
      allSensors: "Tutti i sensori",
      selSensor: "Sens. selezionato",
      /* Graphs */
      displacementGraph: "Grafico del Displacement",
      accelerationsGraph: "Grafico delle Accelerazioni",
      tiltGraph: "Grafico degli Angoli",
      tilt3dGraph: "Angolo di variazione 3D",
      crackGraph: "Grafico delle Estensioni",
      temperatureGraph: "Grafico delle Temperature",
      densProb: "Densità di probabilità",
      freqApp: "Frequenza di apparizione",
      deflectionGraph: "Deformata",
      deflectionDesc: "Grafico di abbassamento della struttura",
      /* Infos */
      dataOf: "Dati relativi a",
      dataOfSelectedDevice: "Dati relativi al singolo device selezionato",
      deviceInfo: "Informazioni sul device",
      dateSorting:"Ordina per data",
      last24Data: "Dati delle ultime 24h",
      lastTemperature: "Ultima temperatura registrata",
      lastTX: "Ultima TX",
      samples: "Campionamenti",
      deviceData: "Dati relativi a Dev_EUI",
      deckMultiData: "Dati relativi a tutti i device Deck selezionati",
      maxPeak: "Picco massimo",
      minPeak: "Picco minimo",
      peakToPeak: "Picco Picco",
      maxAcceleration: "Accelerazione massime",
      maxCrack: "Estensione massima",
      maxTilt: "Angolo massimo",
      minTemp: "Temperatura minima",
      maxTemp: "Temperatura massima",
      dailyAverageEvents: "Media eventi giornalieri",
      counterEvents: "Numero totale eventi",
      thresholdCrossingCount: "Superamenti della soglia",
      selectedDevices: "Dispositivi selezionati",
      meanValue: "Valore medio",
      minValue: "Valore min",
      maxValue: "Valore max",
      variance: "Varianza",
      stdDeviation: "Deviazione Std.",
      /* Functions */
      dataCompensation: "Compensazioni dati",
      sampleRate: "Frequenza di campionamento",
      resolution: "Risoluzione",
      activationThreshold: "Attivazione",
      compensation: "Compensazione",
      mesUnit: "Unità di misura"
    },
  },
};

// Create VueI18n instance with options
export const i18n = new VueI18n({
  locale: navigator.language,
  silentFallbackWarn: true,
  fallbackLocale: {
    /* 1 */ 'it-IT': ['it'],
    /* 6 */ 'default': ['en'],
  },
  messages // set locale messages
});

console.log("Setto lingua -> " + navigator.language)

//    this.$root.$i18n.locale = "en"
